<template>
  <div class="wt-container align-items-center">
    <div class="card shadow-sm p-4">
      <h2 class="text-center mb-4">{{ state.headerText }}</h2>
      <p :innerHTML="state.leadText" class="lead text-center mb-4"></p>
      <Errors @dismiss="errors = []" :errors="errors"/>
      <template v-if="state != states[3]">
        <form @submit.prevent="submit">
          <div class="mb-3">
            <label for="email" class="form-label">Email Address</label>
            <input type="text" v-model="emailAddress" :disabled="loading" id="email" class="form-control"/>
          </div>
          <div class="mb-3">
            <label for="password" class="form-label">Password</label>
            <input type="password" v-model="password" :disabled="loading" id="password" class="form-control"/>
          </div>
          <div v-if="state == states[1]" class="form-check mb-3">
            <input type="checkbox" v-model="agreed" id="agreed" class="form-check-input">
            <label for="agreed" class="form-check-label">
              I agree that the development team can access my input data for internal evaluation<br/>
              and that Water Footprint Implementation may contact me using my registration details.
            </label>
          </div>
          <button type="submit" :disabled="loading" class="btn btn-primary w-100 mb-3">{{ state.submitText }}</button>
        </form>
      </template>
      <div v-if="state != states[0]" class="text-center">
        <button type="button" @click="setState(0)" class="btn btn-link">
          <span v-if="state == states[1]">Login to an existing account</span>
          <span v-if="state == states[2]">Login with your existing password</span>
          <span v-if="state == states[3]">Login with your new credentials</span>
        </button>
      </div>
      <div v-if="state == states[0]" class="text-center">
        <button type="button" @click="setState(1)" class="btn btn-link">Register a new account</button>
      </div>
      <div v-if="state == states[0]" class="text-center">
        <button type="button" @click="setState(2)" class="btn btn-link">Forgot your password?</button>
      </div>
      <div v-if="state != states[3]" class="text-center">
        <button type="button" @click="cancel" class="btn btn-link">Continue as anonymous user</button>
      </div>
    </div>
  </div>
</template>

<script>
import Errors from "@/components/shared/Errors.vue";
import { assessment } from "@/services/assessment-model";
import { userModel } from "@/services/user-model";

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export default {
  name: "Login",
  components: {
    Errors
  },
  data() {
    return {
      states: [
        { headerText: "Login to Your Account", leadText: "Enter your email address and password to login to the Water Footprint Assessment Tool.", submitText: "Login" },
        { headerText: "New Account", leadText: "Register an email address and password<br/>that you want to use for your new account.", submitText: "Register" },
        { headerText: "Change Your Password", leadText: "Enter your email address and the new password that you want to use.", submitText: "Change" },
        { headerText: "Sent", leadText: "Please check your mailbox. A confirmation mail has been sent to you. It contains a link to activate your new credentials." }
      ],
      state: null,
      emailAddress: "",
      password: "",
      agreed: false,
      errors: []
    };
  },
  created() {
    this.state = this.states[0];
  },
  computed: {
    loading() {
      return userModel.status == "loading";
    },
    error() {
      return userModel.status == "error";
    }
  },
  watch: {
    error(val) {
      this.errors = [];
      if (val) {
        this.errors.push("Email address and/or password not correct.");
      }
    }
  },
  methods: {
    submit() {
      this.validate();
      if (this.errors.length == 0) {
        if (this.state == this.states[0]) {
          userModel.login(this.emailAddress, this.password);
        } else {
          userModel.register(this.emailAddress, this.password);
          this.state = this.states[3];
        }
      }
    },
    validate() {
      this.errors = [];
      if (this.emailAddress.length == 0) {
        this.errors.push("An email address is required.");
      } else if (!emailRegex.test(this.emailAddress)) {
        this.errors.push("That is not a valid email address.");
      }
      if (this.password.length == 0) {
        this.errors.push("A password is required.");
      }
      if ((this.state == this.states[1]) && !this.agreed) {
        this.errors.push("You haven't agreed yet to the terms of use.");
      }
    },
    setState(i) {
      this.errors = [];
      this.state = this.states[i];
    },
    cancel() {
      userModel.logout();
      if (assessment.isProduction()) {
        assessment.setAssessmentType(null);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  width: 100%;
  max-width: 470px;
  margin: auto 0;
}
</style>